import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAppSettingConfigModel } from '../../models/app-setting/app-setting.model';
import { AppSettingAPIService } from '../api/app-setting.api.service';
import { BaseDataStore } from './base-data.store';

@Injectable({ providedIn: 'root' })
export class AppSettingStore extends BaseDataStore {
  private _appSetting: BehaviorSubject<IAppSettingConfigModel | null> = new BehaviorSubject<IAppSettingConfigModel | null>(null);

  public $appSetting: Observable<IAppSettingConfigModel | null> = this._appSetting.asObservable();

  get appSetting(): IAppSettingConfigModel | null {
    return this._appSetting.getValue();
  }

  set appSetting(setting: IAppSettingConfigModel) {
    this._appSetting.next(setting);
  }

  constructor(private appSettingAPIService: AppSettingAPIService) {
    super();
    this.behaviorSubjectList.push(this._appSetting);
  }

  public loadInitialData(): void {
    this.appSettingAPIService.getAppSettingJSON().subscribe({
      next: (x) => {
        if (x) {
          this.appSetting = x;
        }
      },
      error: (err) => console.error('AppSetting load failed', err),
    });
  }
}
